import { Period } from '../util/dates';

import { EmptyState, EmptyStateSize } from '@pdcplan/shared/components';
import { MessageViewTab } from '../routes';
import colorVarMap from '@pdcfrontendui/components/colors';
import { currentLanguage } from '../currentLanguage';
import { useFormatter } from '../hooks/useLang';

function NoMessagesImage() {
  return (
    <svg
      width="221px"
      height="203px"
      viewBox="0 0 221 203"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-0, 0)">
          <rect x="11.0213608" y="0" width="203" height="203"></rect>
          <path
            d="M165.232813,56.2670374 C183.922128,66.3768575 206.985537,71.24906 210.69689,82.8205408 C214.408244,94.5138267 198.767541,113.150001 193.067963,131.42076 C187.368384,149.691519 191.742479,167.596863 184.452321,177.341268 C177.162163,187.207478 158.207752,189.034554 142.434501,187.207478 C126.661249,185.502207 113.93661,180.26459 95.114747,181.117225 C76.4254325,181.848056 51.6388949,188.669139 34.2750637,182.700691 C17.0437809,176.732243 7.10265613,157.852459 10.4163644,140.79975 C13.7300726,123.868846 30.2986138,108.521409 38.7817069,89.3980141 C47.3973483,70.2746195 48.06009,47.2534629 59.8568913,34.2203213 C71.6536927,21.1871798 94.717102,18.0202482 113.406417,24.2323063 C132.095731,30.4443644 146.410951,46.0354123 165.232813,56.2670374 Z"
            fill={colorVarMap.colorPrimaryLightest}
            fillRule="nonzero"
            transform="translate(110.5214, 104.5) rotate(-7.3085) translate(-110.5214, -104.5)"
          ></path>
          <polygon
            fill="#EBF8F8"
            points="61.1863788 68.9316421 159.857512 68.9316421 159.857512 145.844622 120.07565 147.963677 110.521945 161.137411 97.2914351 147.963677 61.1863788 145.844622"
          ></polygon>
          <ellipse
            fill={colorVarMap.colorPrimaryDark}
            fillRule="nonzero"
            cx="110.179335"
            cy="121.852404"
            rx="5.83437247"
            ry="5.93584652"
          ></ellipse>
          <path
            d="M173.17565,64.2703899 L173.17565,59.9918135 L180.813818,51.066783 C182.067587,49.6112672 182.995141,48.5796105 183.596479,47.9638154 C182.969987,48.0038021 182.144621,48.0277941 181.121168,48.0437888 L173.924767,48.0837755 L173.924767,43.5332895 L190.774014,43.5332895 L190.774014,47.4199963 L182.982564,56.560955 L180.23842,59.5839492 C181.735083,59.4959784 182.662637,59.4479944 183.021081,59.4479944 L191.369063,59.4479944 L191.369063,64.2703899 L173.17565,64.2703899 Z"
            fill={colorVarMap.colorPrimaryBaseDark}
            fillRule="nonzero"
          ></path>
          <path
            d="M150.557784,39.1626875 L150.557784,32.3738114 L161.999408,18.2123428 C163.877497,15.902856 165.26693,14.265912 166.167706,13.2888214 C165.22925,13.3522689 163.992891,13.3903373 162.459805,13.4157163 L151.679927,13.4791637 L151.679927,6.25884505 L176.919324,6.25884505 L176.919324,12.4259362 L165.24809,26.9300211 L161.137489,31.7266475 C163.379421,31.5870632 164.768854,31.5109262 165.305787,31.5109262 L177.81068,31.5109262 L177.81068,39.1626875 L150.557784,39.1626875 Z"
            fill={colorVarMap.colorPrimaryBaseDark}
            fillRule="nonzero"
          ></path>
          <path
            d="M123.762405,150.981025 L110.179138,170.385694 L96.5958698,150.981025 L60.2814194,150.981025 C57.2376586,150.981025 54.7372285,148.480595 54.7372285,145.436835 L54.7372285,67.8181618 C54.7372285,64.774401 57.2376586,62.2739708 60.2814194,62.2739708 L160.076856,62.2739708 C163.120617,62.2739708 165.621047,64.774401 165.621047,67.8181618 L165.621047,145.436835 C165.621047,148.480595 163.120617,150.981025 160.076856,150.981025 L123.762405,150.981025 Z M117.990903,140.751993 L155.392014,140.751993 L155.392014,72.5030031 L64.9662607,72.5030031 L64.9662607,140.751993 L102.367373,140.751993 L110.179138,152.012245 L117.990903,140.751993 Z"
            fill={colorVarMap.colorPrimaryDark}
            fillRule="nonzero"
          ></path>
          <g
            transform="translate(79.9212, 96.0874)"
            fill={colorVarMap.colorPrimaryDark}
            fillRule="nonzero"
          >
            <path d="M2.20029785,0 C3.51078816,3.72756941 6.77472921,6.22061852 10.4346699,6.22061852 C14.0928069,6.22061852 17.3543799,3.73204587 18.666982,0.00816330909 L20.8666492,0.783506708 C19.2357164,5.41050103 15.1171817,8.55293355 10.4346699,8.55293355 C5.7495376,8.55293355 1.62828366,5.40505549 0,0.773552066 L2.20029785,0 Z"></path>
            <path d="M41.2002978,0 C42.5107882,3.72756941 45.7747292,6.22061852 49.4346699,6.22061852 C53.0928069,6.22061852 56.3543799,3.73204587 57.666982,0.00816330909 L59.8666492,0.783506708 C58.2357164,5.41050103 54.1171817,8.55293355 49.4346699,8.55293355 C44.7495376,8.55293355 40.6282837,5.40505549 39,0.773552066 L41.2002978,0 Z"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default function NoMessages({
  tab,
  period,
  className,
}: {
  tab: MessageViewTab;
  period: Period;
  className?: string;
}) {
  const formatter = useFormatter();
  const from = formatter.dayDescription(period.from, true);
  const to = formatter.dayDescription(period.to, true);

  return (
    <div className={className}>
      <EmptyState
        image={NoMessagesImage}
        heading={
          tab === MessageViewTab.Read
            ? currentLanguage.ReadMessagesEmptyStateTitle
            : currentLanguage.UnreadMessagesEmptyStateTitle
        }
        description={
          tab === MessageViewTab.Read
            ? currentLanguage.ReadMessagesEmptyStateDescription_2(from, to)
            : currentLanguage.UnreadMessagesEmptyStateDescription_2(from, to)
        }
        size={EmptyStateSize.Large}
      />
    </div>
  );
}
